import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    planGroupGraphedActiveRequest: ["businessId"],
    planGroupGraphedAllRequest: ["businessId"],
    planGroupGraphedArchivedRequest: ["businessId"],
    planGroupsRequest: ["businessId"],

    planGroupGraphedActiveSuccess: ["planGroupsGraphed"],
    planGroupGraphedAllSuccess: ["planGroupsGraphedAll"],
    planGroupGraphedArchivedSuccess: ["planGroupsGraphed"],
    planGroupsSuccess: ["planGroups"],

    planGroupGraphedActiveFailure: ["error"],
    planGroupGraphedAllFailure: ["error"],
    planGroupGraphedArchivedFailure: ["error"],
    planGroupsFailure: ["error"],
    planRequest: ["businessId", "options"],
    planGroupCreateRequest: ["planGroup"],
    planGroupUpdateRequest: ["planGroupId", "planGroup"],
    addWatcherRequest: ["watcher"],
    removeWatcherRequest: ["watcherId"],
    getProductWatcherRequest: ["planGroupId"],
    leaderBoardRequest: ["planGroupId"],

    planSuccess: ["plan"],
    planGroupCreateSuccess: ["createdPlanGroup"],
    planGroupUpdateSuccess: ["updatedPlanGroup"],
    addWatcherSuccess: ["watcher"],
    removeWatcherSuccess: ["watcherId"],
    productWatcherSuccess: ["watcher"],
    leaderBoardSuccess: ["boardUrl"],

    planFailure: ["error"],
    planGroupCreateFailure: ["error"],
    planGroupUpdateFailure: ["error"],
    addWatcherFailure: ["error"],
    removeWatcherFailure: ["error"],
    productWatcherFailure: ["error"],
    leaderBoardFailure: ["error"],
})

export const PlanGroupTypes = Types
export default Creators
